// Copyright (c) 2016 Deere & Company

import Report, {getDefaultState} from '../../pins-not-registered/state/report';
import actions from '../../actions-list';

const updatePinsNotRegisteredReport = (state, action) =>
    Report.update(state, {
        $set: action.data
    });

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.CREATE_PINS_NOT_REGISTERED_REPORT_SUCCESS]: updatePinsNotRegisteredReport,
        [actions.RESET_REPORT_SEARCH_RESULTS]: updatePinsNotRegisteredReport
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reports/pins-not-registered/reducers/report.js